import React, { Component } from 'react';
import HorizontalTimeline from 'react-horizontal-timeline';

/**
 * Estilos.
 */
const buttonStyle = {
    //TODO: no debería estar acá, debe ir en Portico
    position: 'absolute',
    marginTop: '71px',
    zIndex: '1'
};

/**
 * Estilos.
 */
const timelineContainerStyles = {
    //TODO: no debería estar acá, debe ir en Portico
    width: '650px',
    height: '100px',
    margin: '44px auto 12px auto',
    position: 'relative'
}

/**
 *  Función para obtener titulos de los puntos en la linea del tiempo. Si es el último índice se titula "al día de hoy".
 * @param {any} date
 * @param {any} indice
 * @param {any} ultimoIndice
 */
function obtenerRotulo(date, indice, ultimoIndice) {
    if (indice === ultimoIndice)
        return "Al día de hoy";
    else
        return "Cierre al " + date.split("T")[0];
}

const BotonCargarMas = ({ visible, cargarFn }) => {
    return <button style={buttonStyle} className="btn btn-primary" onClick={cargarFn}>Visualizar más</button>;
}

/**
 * Objeto de configuración de la linea de tiempo.
 */
const config = {
    minEventPadding: 50,
    maxEventPadding: 50,
    linePadding: 100,
    labelWidth: 130,
    fillingMotionStiffness: 150,
    fillingMotionDamping: 25,
    slidingMotionStiffness: 150,
    slidingMotionDamping: 25,
    stylesBackground: '#f8f8f8',
    stylesForeground: '#00a5ff',
    stylesOutline: '#dfdfdf',
    isTouchEnabled: true,
    isKeyboardEnabled: true,
    isOpenEnding: true,
    isOpenBeginning: true
};


class TimelineSaldos extends Component {

    constructor(props) {
        super(props);
        const dates = this.props.content.map(d => d.date).sort();
        const lastIndex = dates.length - 1;

        this.state = {
            visualizarBotonCarga: false,
            dates: dates,
            value: lastIndex,
            ultimoIndex: lastIndex,
            previous: 0
        };
    }

    componentWillReceiveProps(nextProps) {
        const dates = nextProps.content.map(d => d.date).sort();

        const cantidadMax = dates.length;
        const cantidadActual = this.state.dates.length;
        const diferencia = cantidadMax - cantidadActual;
        const valorActual = this.state.value + diferencia;

        const lastIndex = dates.length - 1;

        this.setState({ dates: dates, ultimoIndex: lastIndex, value: valorActual });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const cantFechas = this.props.content.length;
        const cantDatosNuevos = nextProps.content.length;

        if (cantFechas === cantDatosNuevos && this.state.value === nextState.value)
            return false;

        return true;
    }

    setIndex(index, value) {
        this.setState({ value: index, previous: value });
    }

    cargarMasDatos() {
        this.props.cargarDatosFn(this.state.dates[0]);
    }

    render() {
        const { value, ultimoIndex, visualizarBotonCarga } = this.state;
        const setIndex = this.setIndex.bind(this);
        const { dates } = this.state;

        if (dates.length === 0)
            return null;

        const contentOrdenadoPorFecha = this.props.content.sort(function (a, b) {
            if (a.date > b.date) {
                return 1;
            }
            return 0;
        });

        return (
            <div>
                <BotonCargarMas visible={true} cargarFn={this.cargarMasDatos.bind(this)} />

                <div>
                    <div style={timelineContainerStyles} className="timeline-container">
                        <HorizontalTimeline
                            fillingMotion={{ stiffness: config.fillingMotionStiffness, damping: config.fillingMotionDamping }}
                            isKeyboardEnabled={config.isKeyboardEnabled}
                            isTouchEnabled={config.isTouchEnabled}
                            labelWidth={config.labelWidth}
                            linePadding={config.linePadding}
                            maxEventPadding={config.maxEventPadding}
                            minEventPadding={config.minEventPadding}
                            slidingMotion={{ stiffness: config.slidingMotionStiffness, damping: config.slidingMotionDamping }}
                            styles={{ background: config.stylesBackground, foreground: config.stylesForeground, outline: config.stylesOutline }}
                            isOpenEnding={config.isOpenEnding}
                            isOpenBeginning={config.isOpenBeginning}
                            getLabel={(date, index) => obtenerRotulo(date, index, ultimoIndex)}
                            index={value}
                            indexClick={(index) => {
                                setIndex(index, value);
                            }}
                            values={dates}
                        />
                    </div>

                    <div className='text-center'>
                        {contentOrdenadoPorFecha[value].component}
                    </div>

                </div>

            </div>
        );
    }
}

export default TimelineSaldos;